module.exports = __webpack_public_path__ + "static/media/download.daedff64.svg";